import currencyFormatter, { currencies } from 'currency-formatter'

const currencyMNT = currencies && currencies.find(
  currency => currency.code === 'MNT'
)

if (currencyMNT) {
  Object.assign(currencyMNT, {
    thousandsSeparator: ',',
    decimalSeparator: '.',
    decimalDigits: 0
  })
}

export default {
  name: 'regExp',
  htmlCommentSingle: /<!--(.*?)-->/gm,
  naturalNumber: /^[1-9]\d*$/,
  expEmail: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/,
  expPhone: /^\d{2,3}-\d{3,4}-\d{4}$/,
  image: /(png|jpeg|svg|jpg|gif)$/,
  video: /(mp4|ogg|webm)$/,
  numberOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },
  priceOnly: function (num) {
    return num.toString().replace(/[^0-9.]/g, '')
  },
  comma: function (num) {
    const reg = /^([-+]?\d+)(\d{3})(\.\d+)?/
    let string = num != null
      ? '' + Math.round(num * 100) / 100
      : ''
    string = string.replace(/[^-+.\d]/g, '')
    while (reg.test(string)) string = string.replace(reg, '$1' + ',' + '$2' + '$3')
    return string
  },
  uncomma: function (str) {
    str = `${str}`
    return str.replace(/[^-.\d]/g, '')
  },
  replaceAllEmpty: function (str) {
    str = `${str}`
    return str.replace(/(\s*)/g, '').toLowerCase()
  },
  priceFormat: function (price, code, disabledSymbol) {
    const format = currencyFormatter.format(price, { code: (code || '').toUpperCase(), ...disabledSymbol && {symbol: ''} })
    const formatArr = format.split('')
    const regex = new RegExp(/[0-9]/)
    const firstNumber = formatArr.findIndex((e) => regex.test(e))
    formatArr[firstNumber] = disabledSymbol ? formatArr[firstNumber] : ' ' + formatArr[firstNumber]
    return formatArr.join('')
  },
  priceUnFormat: function (price, code) {
    return currencyFormatter.unformat(price, { code: code })
  },
  priceTotal: function (price, quantity, code) {
    const currencyInfo = currencies[code] || { decimalDigits: 2 }
    const decimalDigits = currencyInfo.decimalDigits // 통화별 소수점 자리수 가져오기
    const totalPrice = price * quantity // 단순 계산
    return Number(totalPrice.toFixed(decimalDigits)) // 소수점 자리수 반영 후 변환
  },
  fillPad: function (str, length, pad) { // 남는 자리수만큼 pad로 채움 (없으면 0)
    str = `${str}`
    return str.length >= length ? str : new Array(length - str.length + 1).join(pad || '0') + str
  },
  toCapitalized: (str) => {
    str = `${str}`
    return str.charAt(0).toUpperCase() + str.slice(1)
  },
  priceDutyFree: str => {
    const price = Number(str)
    return Math.round(price / 1.1)
  }
}